import { mergeStyleSets, useTheme } from "@fluentui/react";

export const useStyles = () => {
  const theme = useTheme();

  return mergeStyleSets({
    executionConfirmation: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      height: '125px',
      width: '295px',
    },
    header: {
      fontSize: theme.fonts.xLarge.fontSize,
      fontWeight: theme.fonts.xLarge.fontWeight,
    },
    content: {
      flexGrow: 1,
      color: theme.palette.neutralTertiary,
    },
    buttonPanel: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '8px',
    }
  });
}
